<template>
  <div class="inquiry">
    <div class="print-header">
      <img src="../assets/img/logo_print.png" alt="Alexander Electric" />
      <p>
        <strong>Заработки за период:</strong>
        {{ formatedFromDate }} - {{ formatedToDate }}
      </p>
    </div>
    <p class="print-name" v-if="inquiry.worker._id">
      {{ inquiry.worker.name }}
    </p>
    <div class="inquiry-header">
      <h2 v-if="!reports.length" class="desktop">Създаване на справка</h2>
      <h2 v-else class="desktop">Преглед на справка</h2>
      <div class="inquiry-header-controlls" ref="top" v-if="!noEarnings">
        <span class="inquiry-pre-datepicker-text desktop">Отчетен период</span>
        <div class="inquiry-datepicker">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="miv">D</span>
              <input
                type="text"
                placeholder="От дата"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="formatedFromDate"
                readonly
              />
            </div>
          </div>
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="miv">D</span>
              <input
                type="text"
                placeholder="До дата"
                @click="openDropdown(1)"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="formatedToDate"
                readonly
              />
            </div>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.fromDate"
              @selected="closeDropdown(0), changeDatePeriod('none')"
            ></datepicker>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active': openedDropdown[1] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.toDate"
              @selected="closeDropdown(1), changeDatePeriod('none')"
            ></datepicker>
          </div>
        </div>
        <div class="date-toggles">
          <span
            class="miv2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'today' }"
            @click="changeDatePeriod('today')"
            title="Отчети за днес"
            >b</span
          >
          <span
            class="miv2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'yesterday' }"
            @click="changeDatePeriod('yesterday')"
            title="Отчети за вчера"
            >c</span
          >
          <span
            class="miv2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'current' }"
            @click="changeDatePeriod('current')"
            title="Отчети за текущия месец"
            >d</span
          >
          <span
            class="miv2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'previous' }"
            @click="changeDatePeriod('previous')"
            title="Отчети за предишния месец"
            >e</span
          >
        </div>
      </div>
    </div>
    <div class="inquiry-filters">
      <div class="inquiry-filters-inputs">
        <!-- DESKTOP COMPANY  -->
        <div class="new-input-wrapper">
          <label>Фирма</label>
          <div class="new-input">
            <span class="miv">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.company._id"
              type="text"
              placeholder="Фирма"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="searchCompanies"
              :disabled="noEarnings || showUnreported"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Фирма"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="inquiry.company.companyName"
              :disabled="inquiry.company._id || noEarnings || showUnreported"
            />
            <span
              v-if="inquiry.company._id"
              class="clear"
              @click="resetSelectedCompany()"
              >F</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[2] }"
          >
            <ul>
              <li
                v-for="c in filteredCompanies()"
                :key="c._id"
                @click="selectCompany(c)"
              >
                {{ c.companyName }}
              </li>
              <!-- <li v-for="c in companies" :key="c._id">{{c.companyName}}</li> -->
            </ul>
          </div>
        </div>
        <!-- MOBILE COMPANY -->
        <!-- <div class="new-input-wrapper mobile">
        <label>Фирма</label>
        <div class="new-input">
          <span class="miv">N</span>
            <select class="select" v-model="company" @change="selectCompany(company), getProjects()">
              <option value="" disabled >Фирма</option> 
              <option value="" >Фирми:</option>            
              <option
                placeholder="Фирма" 
                v-for="c in companies" :key="c._id"
                :value="c"
              >{{c.companyName}}</option>              
            </select>            
        </div>
        </div>-->
        <!-- PROJECT -->
        <div class="new-input-wrapper">
          <label>Проект</label>
          <div class="new-input">
            <span class="miv">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.project._id"
              type="text"
              placeholder="Проект"
              @focus="getProjects(), openDropdown(3)"
              @blur="closeDropdown(3)"
              v-model="searchProjects"
              :disabled="noEarnings || showUnreported"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Проект"
              @focus="getProjects(), openDropdown(3)"
              @blur="closeDropdown(3)"
              v-model="inquiry.project.projectName"
              :disabled="inquiry.project._id || noEarnings || showUnreported"
            />
            <span
              v-if="inquiry.project._id"
              class="clear"
              @click="resetSelectedProject()"
              >F</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
          >
            <ul>
              <li
                v-for="p in filteredProjects()"
                :key="p._id"
                @click="selectProject(p)"
              >
                {{ p.projectName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- PROJECT MOBILE -->
        <!-- <div class="new-input-wrapper mobile">
          <label>Проект</label>
          <div class="new-input">
          <span class="miv">N</span>
          <select class="select" v-model="project" @change="selectProject(project), getObjects()">
            <option value="" disabled hidden>Проект</option>
            <option :value="p" v-for="p in projects" :key="p._id">{{p.projectName}}</option>
          </select>
          </div>
        </div>-->
        <!-- ОBJECT -->
        <div class="new-input-wrapper">
          <label>Обект</label>
          <div class="new-input">
            <span class="miv">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.object._id"
              type="text"
              placeholder="Обект"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="searchObjects"
              :disabled="noEarnings || showUnreported"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Обект"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="inquiry.object.objectName"
              :disabled="inquiry.object._id || noEarnings || showUnreported"
            />
            <span
              v-if="inquiry.object._id"
              class="clear"
              @click="resetSelectedObject()"
              >F</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[4] }"
          >
            <ul>
              <li
                v-for="o in filteredObjects()"
                :key="o._id"
                @click="selectObject(o)"
              >
                {{ o.objectName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- OBJECT MOBILE -->
        <!-- <div class="new-input-wrapper mobile">
          <label>Обект</label>
          <div class="new-input">
          <span class="miv">N</span>
          <select class="select" v-model="object" @change="selectObject(object), getParts()">
            <option value="" disabled hidden>Обект</option>
            <option :value="o" v-for="o in objects" :key="o._id">{{o.objectName}}</option>
          </select>
          </div>
        </div>-->
        <!-- PART -->
        <div class="new-input-wrapper">
          <label>Част</label>
          <div class="new-input">
            <span class="miv">N</span>
            <input
              v-if="!inquiry.part._id"
              type="text"
              placeholder="Част"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="searchParts"
              :disabled="noEarnings || showUnreported"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Част"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="inquiry.part.partName"
              :disabled="inquiry.part._id || noEarnings || showUnreported"
            />
            <span
              v-if="inquiry.part._id"
              class="clear"
              @click="resetSelectedPart()"
              >F</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[5] }"
          >
            <ul>
              <li
                v-for="p in filteredParts()"
                :key="p._id"
                @click="selectPart(p)"
              >
                {{ p.partName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- PART MOBILE -->
        <!-- <div class="new-input-wrapper mobile">
          <label>Част</label>
          <div class="new-input">
          <span class="miv">N</span>
          <select class="select" v-model="part" @change="selectPart(part)">
            <option value="" disabled hidden>Част</option>
            <option :value="p" v-for="p in parts" :key="p._id">{{p.partName}}</option>
          </select>
          </div>
        </div>-->
        <!-- DEKTOP REPORTER -->
        <div class="new-input-wrapper">
          <label>Отчетник</label>
          <div class="new-input">
            <span class="miv">N</span>
            <input
              v-if="!inquiry.reporter._id"
              type="text"
              placeholder="Отчетник"
              @focus="getReporters(), openDropdown(6)"
              @blur="closeDropdown(6)"
              v-model="searchReporters"
              :disabled="
                inquiry.worker._id.length > 0 || noEarnings || showUnreported
              "
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Отчетник"
              @focus="getReporters(), openDropdown(6)"
              @blur="closeDropdown(6)"
              v-model="inquiry.reporter.name"
              :disabled="
                inquiry.worker._id.length > 0 ||
                inquiry.reporter._id ||
                noEarnings ||
                showUnreported
              "
            />
            <span
              v-if="inquiry.reporter._id && getUser.permissions.isAdmin"
              class="clear"
              @click="resetSelectedReporter()"
              >F</span
            >
            <span
              v-if="
                inquiry.worker._id.length > 0 ||
                (!getUser.permissions.isAdmin && getUser.permissions.isReporter)
              "
              class="disabled"
              >A</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[6] }"
          >
            <ul>
              <li
                v-for="r in filteredReporters()"
                :key="r._id"
                @click="selectReporter(r)"
              >
                {{ r.name }}
              </li>
            </ul>
          </div>
        </div>
        <!-- MOBILE REPORTER -->
        <!-- <div class="new-input-wrapper mobile">
          <label>Отчетник</label>
          <div class="new-input">
          <span class="miv">N</span>
          <select class="select" v-model="reporter">
            <option value="" disabled hidden>Отчетник</option>
            <option :value="r" v-for="r in reporters" :key="r._id" @click="selectReporter(r)">{{r.name}}</option>
          </select>
          </div>
        </div>-->
        <!-- WORKER -->
        <div class="new-input-wrapper">
          <label>Работник</label>
          <div class="new-input">
            <span class="miv">N</span>
            <input
              v-if="!inquiry.worker._id"
              type="text"
              placeholder="Работник"
              @focus="getWorkers(), openDropdown(7)"
              @blur="closeDropdown(7)"
              v-model="searchWorkers"
              :disabled="
                inquiry.reporter._id.length > 0 || noEarnings || showUnreported
              "
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Работник"
              @focus="getWorkers(), openDropdown(7)"
              @blur="closeDropdown(7)"
              v-model="inquiry.worker.name"
              :disabled="
                inquiry.reporter._id.length > 0 ||
                inquiry.worker._id ||
                noEarnings ||
                showUnreported
              "
            />
            <span
              v-if="inquiry.worker._id"
              class="clear"
              @click="resetSelectedWorker()"
              >F</span
            >
            <span v-if="inquiry.reporter._id.length > 0" class="disabled"
              >A</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[7] }"
          >
            <ul>
              <li
                v-for="w in filteredWorkers()"
                :key="w._id"
                @click="selectWorker(w)"
              >
                {{ w.name }}
              </li>
            </ul>
          </div>
        </div>
        <!-- MOBILE WORKER -->
        <!-- <div class="new-input-wrapper mobile">
          <label>Работник</label>
          <div class="new-input">
          <span class="miv">N</span>
          <select class="select" v-model="worker">
            <option value="" disabled hidden>Отчетник</option>
            <option :value="w" v-for="w in workers" :key="w._id" @click="selectWorker(w)">{{w.name}}</option>
          </select>
          </div>
        </div>-->
      </div>
      <div class="inquiry-filters-btns">
        <div class="checkboxes-wrapper">
          <div class="col">
            <label class="checkbox-wrapper">
              Активни обекти
              <input
                type="checkbox"
                v-model="activeProjects"
                @change="selectActiveProjects()"
              />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Грешни отчети
              <input
                type="checkbox"
                v-model="inquiry.isInvalid"
                @change="selectInvalid()"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col">
            <label class="checkbox-wrapper">
              Покажи неотчетени
              <input
                type="checkbox"
                v-model="showUnreported"
                @change="selectShowUnreported()"
              />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Без ст-ст на заработка
              <input
                type="checkbox"
                v-model="noEarnings"
                @change="selectNoEarnings()"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col">
            <label class="radio">
              <input
                type="radio"
                name="radio"
                :value="false"
                v-model="showByReport"
                @input="selectSwitch(!showByReport)"
              />
              Общи заработки
            </label>
            <label class="radio">
              <input
                type="radio"
                name="radio"
                :value="true"
                v-model="showByReport"
                @input="selectSwitch(!showByReport)"
              />
              Заработки по отчети
            </label>
          </div>
          <div class="col">
            <label
              class="checkbox-wrapper"
              title="Показва само отчети и дейности, които са актувани"
            >
              Покажи актувани
              <input
                type="checkbox"
                v-model="showLogged"
                :disabled="!showNonLogged"
                @change="getInquiry()"
              />
              <span class="checkmark"></span>
            </label>
            <label
              class="checkbox-wrapper"
              title="Показва само отчети и дейности, които НЕ са актувани"
            >
              Покажи неактувани
              <input
                type="checkbox"
                v-model="showNonLogged"
                :disabled="!showLogged"
                @change="getInquiry()"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col" v-if="reports.length">
            <p
              title="Актуване на всички отчети в текущата справка"
              :class="{ 'log-action--disabled': showLogged }"
              class="log-action"
              @click="toggleLogged(true)"
            >
              <img src="../assets/img/inquiry/log-all.svg" alt="" />
              <span>Актувай всичко</span>
            </p>
            <p
              title="Премахва актуването от всички отчети в текущата справка"
              :class="{ 'log-action--disabled': showNonLogged }"
              class="log-action"
              @click="toggleLogged(false)"
            >
              <img src="../assets/img/inquiry/remove-logs.svg" />
              <span>Махни актуването</span>
            </p>
          </div>
        </div>
        <!-- <div class="switch-wrapper">
            <label
              class="switch-label"
              :class="{ 'switch-label-active': !showByReport }"
              @click="selectSwitch(false)"
              >Общи заработки</label
            >
            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="showByReport"
                  @input="selectSwitch(!showByReport)"
                />
                <span class="slider"></span>
              </label>
            </div>
            <label
              class="switch-label"
              :class="{ 'switch-label-active': showByReport }"
              @click="selectSwitch(true)"
              >Заработки по отчети</label
            >
          </div> -->
        <button
          v-if="!reports.length"
          class="btn btn-new"
          @click="getInquiry()"
        >
          Направи справка
        </button>

        <div class="btns desktop" v-else>
          <!-- @click="exportFile()" -->
          <button
            class="btn btn-print"
            @click="print()"
            v-if="inquiry.worker._id"
          >
            <span class="miv"></span>
            Печат
          </button>
          <button
            class="btn btn-excel"
            @click="exportToExcelFile()"
            v-if="!noEarnings"
          >
            <span class="miv">E</span>
            Експорт в Excel
          </button>
          <button class="btn btn-reset" @click="resetInquiry()">
            <span class="miv">F</span>
            Нулирай филтри
          </button>
        </div>
      </div>
    </div>
    <div class="inquiry-title-wrapper" v-if="isInquiryMade">
      <h3 class="inquiry-title" ref="reports" v-if="noEarnings">
        Справка по обекти, с дейности без въведена стойност на заработка
      </h3>
      <h3 class="inquiry-title" ref="reports" v-else-if="showUnreported">
        Справка планирано/отчетено <span>за периода - от&nbsp;</span>
        <strong>{{ formatedFromDate }}</strong>
        <span>&nbsp;до&nbsp;</span>
        <strong>{{ formatedToDate }}</strong>
      </h3>
      <template v-else>
        <h3
          class="inquiry-title"
          :class="{ 'inquiry-title-invalid': !activeProjects }"
          ref="reports"
        >
          <span>Справка&nbsp;</span>
          <span v-if="inquiry.company._id">
            <span>за фирма&nbsp;</span>
            <strong>{{ inquiry.company.companyName }}</strong>
          </span>
          <span v-else>
            <span>
              по
              <span v-if="inquiry.isInvalid">грешни&nbsp;</span>отчети за&nbsp;
            </span>
            <strong>
              всички
              <span v-if="!activeProjects">неактивни&nbsp;</span>фирми
            </strong>
          </span>
          <span v-if="inquiry.project._id">
            <span>, проект&nbsp;</span>
            <strong>{{ inquiry.project.projectName }}</strong>
          </span>
          <span v-if="inquiry.object._id">
            <span>, обект&nbsp;</span>
            <strong>{{ inquiry.object.objectName }}</strong>
          </span>
          <span v-if="inquiry.part._id">
            <span>, част&nbsp;</span>
            <strong>{{ inquiry.part.partName }}</strong>
          </span>
          <span v-if="inquiry.reporter._id">
            <span>, отчетник&nbsp;</span>
            <strong>{{ inquiry.reporter.name }}</strong>
          </span>
          <span v-if="inquiry.worker._id">
            <span>, работник&nbsp;</span>
            <strong>{{ inquiry.worker.name }}</strong>
          </span>
          <span>,</span>
        </h3>
        <h3
          class="inquiry-title"
          :class="{ 'inquiry-title-invalid': !activeProjects }"
        >
          <span>за периода - от&nbsp;</span>
          <strong>{{ formatedFromDate }}</strong>
          <span>&nbsp;до&nbsp;</span>
          <strong>{{ formatedToDate }}</strong>
        </h3>
      </template>
    </div>
    <template v-if="noEarnings">
      <template v-if="isInquiryMade">
        <div class="reports">
          <div class="reports-content">
            <!-- REPORTS -->
            <div class="table-wrapper">
              <table class="table" ref="reportsTable">
                <thead>
                  <tr>
                    <th>Фирма</th>
                    <th>Проект</th>
                    <th>Обект</th>
                    <th class="right">Дейности без ст-ст на заработка</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, i) in reports" :key="`r-c-${i}`">
                    <td>
                      <span class="no-wrap">{{ r.company }}</span>
                    </td>
                    <td>
                      <span class="no-wrap">{{ r.project }}</span>
                    </td>
                    <td>
                      <span class="no-wrap">{{ r.object }}</span>
                    </td>
                    <td class="right">
                      <router-link
                        class="link"
                        :to="`/companies/${r._id}/${r.projectId}/${r.objectId}?from=${getLocation}`"
                      >
                        <span class="no-wrap">{{ r.activities.length }}</span>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="isInquiryMade && !reports.length">
                    <td colspan="4" class="td-center">
                      Няма добавени отчети за избраните параметри.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else-if="showUnreported">
      <template v-if="isInquiryMade">
        <div class="reports">
          <div class="reports-content">
            <!-- REPORTS -->
            <div class="table-wrapper">
              <table class="table" ref="reportsTable">
                <thead>
                  <tr>
                    <th>Служител</th>
                    <th class="center">Планирани дни брой</th>
                    <th class="center">Планирани дни/обекти</th>
                    <th class="center">Отчетени дни брой</th>
                    <th class="center">Отчетени дни/обекти</th>
                    <th class="center">Разлика</th>
                    <th class="center">Липсващи отчети</th>
                  </tr>
                </thead>
                <tbody class="vab">
                  <template v-for="(r, i) in reports">
                    <template v-for="(nt, j) in r.largest">
                      <tr
                        :class="{ 'tr--main': j === 0 }"
                        :key="`r-c-${i}-${j}`"
                        v-if="
                          r.loaded &&
                          (r.notReported ? r.notReported.length : false)
                        "
                      >
                        <td>
                          <span v-if="j === 0" class="no-wrap">{{
                            r.name
                          }}</span>
                        </td>
                        <td class="center">
                          <p v-if="j === 0">
                            {{ r.calendars ? r.calendars.length : 0 }}
                          </p>
                        </td>
                        <td class="td--dates">
                          <section>
                            <p
                              v-if="r.calendars && r.calendars[j]"
                              class="not-reported"
                            >
                              {{
                                `${r.calendars[j].date} ${
                                  r.calendars[j].object
                                    ? "- " +
                                      r.calendars[j].object.map(
                                        (s, i) => (i !== 0 ? "🔵" : "") + s
                                      )
                                    : ""
                                }`
                              }}
                            </p>
                          </section>
                        </td>
                        <td class="center">
                          <p v-if="j === 0">
                            {{ r.reports ? r.reports.length : 0 }}
                          </p>
                        </td>
                        <td class="td--dates">
                          <section>
                            <p
                              v-if="r.reports && r.reports[j]"
                              class="not-reported"
                            >
                              {{
                                `${r.reports[j].date} ${
                                  r.reports[j].object
                                    ? "- " +
                                      r.reports[j].object.map(
                                        (s, i) => (i !== 0 ? "🔵" : "") + s
                                      )
                                    : ""
                                }`
                              }}
                            </p>
                          </section>
                        </td>
                        <td class="center">
                          <span
                            v-if="j === 0"
                            :class="{ difference: r.difference !== 0 }"
                            >{{ r.difference }}</span
                          >
                        </td>
                        <td class="td--dates">
                          <p
                            v-if="r.notReported && r.notReported[j]"
                            class="not-reported"
                          >
                            {{
                              `${r.notReported[j].date} ${
                                r.notReported[j].object
                                  ? "- " +
                                    r.notReported[j].object.map(
                                      (s, i) => (i !== 0 ? "🔵" : "") + s
                                    )
                                  : ""
                              }`
                            }}
                          </p>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <tr v-if="isInquiryMade && !reports.length">
                    <td colspan="5" class="td-center">
                      Няма добавени отчети за избраните параметри.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div
        class="no-reports"
        v-if="
          isInquiryMade && plannedVsReported
            ? !reports.companies
            : !reports.length
        "
        ref="no-reports"
      >
        <p v-if="getLoading">Зареждане...</p>
        <p v-else>Няма добавени отчети за избраните параметри.</p>
      </div>
      <div
        class="reports"
        v-if="(isInquiryMade && reports.length) || reports.companies"
      >
        <div class="reports-tabs">
          <button
            class="reports-tab"
            :class="{ 'reports-tab-active': activeTab === 3 }"
            @click="selectTab(3)"
          >
            <span>Отчети</span>
            <!-- <span v-if="!this.inquiry.worker._id">({{ reports.length }})</span> -->
          </button>
          <button
            class="reports-tab"
            :class="{ 'reports-tab-active': activeTab === 1 }"
            @click="selectTab(1)"
          >
            <span>Дейности</span>
            <!-- <span v-if="!this.inquiry.worker._id"
            >({{ totalActivityItems }})</span
          > -->
          </button>
          <button
            class="reports-tab"
            :class="{ 'reports-tab-active': activeTab === 2 }"
            @click="selectTab(2)"
          >
            <span>Заработки</span>
          </button>
          <!-- <button
            class="reports-tab"
            :class="{ 'reports-tab-active': activeTab === 4 }"
            @click="selectTab(4)"
          >
            <span>Планирано/Отчетено по обекти</span>
          </button>
          <button
            class="reports-tab"
            :class="{ 'reports-tab-active': activeTab === 5 }"
            @click="selectTab(5)"
          >
            <span>Планирано/Отчетено по служители</span>
          </button> -->
        </div>
        <div class="reports-content">
          <!-- REPORTS -->
          <div class="table-wrapper">
            <table class="table" ref="reportsTable" v-show="activeTab === 3">
              <thead>
                <tr>
                  <th>Дата</th>
                  <th class="center">Дата на създаване</th>
                  <th>Отчетник</th>
                  <th>Фирма</th>
                  <th>Проект</th>
                  <th>Обект</th>
                  <th class="center">
                    Отчетени
                    <br />&nbsp;хора&nbsp;
                  </th>
                  <th class="center">НРВ</th>
                  <th class="no-wrap center">ИРВ</th>
                  <!-- <th class="no-wrap center">ИРВ 2</th> -->
                  <th class="center">Отчетени <br />&nbsp;части&nbsp;</th>
                  <th class="center">
                    Отчетени
                    <br />&nbsp;дейности&nbsp;
                  </th>
                  <th v-if="getUser.permissions.isAdmin" class="center">
                    АКТУВАНО
                  </th>
                </tr>
              </thead>
              <tbody v-if="activeTab === 3">
                <tr
                  v-for="report in renderReports"
                  :key="`report-${report._id}`"
                  @click="goToReport(report._id)"
                  :class="{
                    'tr-invalid': report.isInvalid,
                    'tr--logged': report.isLogged,
                  }"
                >
                  <td>
                    <span class="no-wrap"
                      >{{ report.date | formatDate }} г.</span
                    >
                  </td>
                  <td>
                    <span
                      class="no-wrap center"
                      v-if="
                        new Date(report.createdAt).getTime() >=
                        new Date('2022-12-01').getTime()
                      "
                      >{{ report.createdAt | formatDate }} г.</span
                    >
                  </td>
                  <td>
                    <span>{{ report.createdBy.name }}</span>
                  </td>
                  <td class="td-company-name">
                    <img
                      class="td-invalid-flag"
                      v-if="report.isInvalid"
                      src="../assets/img/flag_yes.svg"
                      alt="invalid"
                    />
                    {{ report.company.companyName }}
                  </td>
                  <td>{{ report.project.projectName }}</td>
                  <td>{{ report.object.objectName }}</td>
                  <td class="center">{{ report.workers.length }}</td>
                  <td class="center">{{ report.calculated.normal }}</td>
                  <td class="center">{{ report.calculated.overtime }}</td>
                  <!-- <td class="center">{{ report.calculated.holiday }}</td> -->
                  <td class="center">
                    {{ report.partsList ? report.partsList.length : "" }}
                  </td>
                  <td class="center">
                    <template v-if="report.activities">{{
                      report.activities.length
                    }}</template>
                  </td>
                  <td class="center" v-if="getUser.permissions.isAdmin">
                    <label class="checkbox-wrapper" @click.stop>
                      <input
                        type="checkbox"
                        v-model="report.isLogged"
                        @change="updateReport(report)"
                      />
                      <span class="checkmark checkmark--green"></span>
                    </label>
                  </td>
                </tr>
                <tr v-if="isInquiryMade && !reports.length">
                  <td colspan="6" class="td-center">
                    Няма добавени отчети за избраните параметри.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ACTIVITIES -->
          <div class="table-wrapper">
            <table class="table" ref="activities" v-show="activeTab === 1">
              <thead>
                <tr>
                  <th>Дата</th>
                  <th class="center">Дата на създаване</th>
                  <th>Отчетник</th>
                  <th>Фирма</th>
                  <th>Проект</th>
                  <th>Обект</th>
                  <th>Част</th>
                  <th>Коментар</th>
                  <th>Дейност</th>
                  <th>Доставка</th>
                  <th>Коментар</th>
                  <th>Количество</th>
                  <th>М.ед.</th>
                  <th
                    class="no-wrap"
                    v-if="
                      getUser.permissions.isSuperAdmin ||
                      getUser.permissions.isAdmin ||
                      getUser.permissions.isHR
                    "
                  >
                    Сума/лв
                  </th>
                  <th v-if="getUser.permissions.isAdmin">
                    АКТУВАНА
                    <br />&nbsp;ДЕЙНОСТ&nbsp;
                  </th>
                </tr>
              </thead>
              <tbody v-if="activeTab === 1">
                <template v-for="r in renderReports">
                  <template v-for="a in r.activities">
                    <tr
                      v-for="(ro, i) in a.rows"
                      :key="`report-${r._id}-activity-${a._id}-row-${i}`"
                      @click="goToReport(r._id)"
                      :class="{
                        'additional-row': a.isAdditional,
                        'tr-invalid': r.isInvalid,
                        'tr--logged': r.isLogged,
                      }"
                    >
                      <td>
                        <span class="no-wrap"
                          >{{ r.date | formatDate }} г.</span
                        >
                      </td>
                      <td>
                        <span
                          class="no-wrap center"
                          v-if="
                            new Date(r.createdAt).getTime() >=
                            new Date('2022-12-01').getTime()
                          "
                          >{{ r.createdAt | formatDate }} г.</span
                        >
                      </td>
                      <td>{{ r.createdBy.name }}</td>
                      <td class="td-company-name">
                        {{ r.company.companyName }}
                      </td>
                      <td>{{ r.project.projectName }}</td>
                      <td>{{ r.object.objectName }}</td>
                      <td>
                        {{ ro.part ? ro.part.partName : "" }}
                      </td>
                      <td>{{ ro.partComment }}</td>
                      <td
                        :class="{
                          'additional-td additional-td-activity':
                            a.isAdditional,
                        }"
                      >
                        {{ a.activityName }}
                      </td>
                      <td>{{ ro.supplier }}</td>
                      <td>{{ ro.supplierComment }}</td>
                      <td>{{ ro.quantity }}</td>
                      <td>{{ a.activityUnit }}</td>
                      <td
                        v-if="
                          getUser.permissions.isSuperAdmin ||
                          getUser.permissions.isAdmin ||
                          getUser.permissions.isHR
                        "
                      >
                        {{ (+ro.price * +ro.quantity) | formatDecimal }}
                      </td>
                      <td class="center" v-if="getUser.permissions.isAdmin">
                        <label class="checkbox-wrapper" @click.stop>
                          <input
                            type="checkbox"
                            :disabled="true"
                            v-model="r.isLogged"
                          />
                          <span class="checkmark checkmark--green"></span>
                        </label>
                      </td>
                    </tr>
                  </template>
                </template>
                <tr v-if="isInquiryMade && !totalActivityItems">
                  <td
                    :colspan="getUser.permissions.isAdmin ? 15 : 14"
                    class="td-center"
                  >
                    Няма извършени дейности за избраните параметри.
                  </td>
                </tr>
                <tr
                  class="sum-row"
                  v-if="
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isAdmin ||
                    getUser.permissions.isHR
                  "
                >
                  <td :colspan="getUser.permissions.isAdmin ? 14 : 13">
                    Обща сума за избраните дейности:
                  </td>
                  <td>{{ totalActivities | formatDecimal }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- WORKERS -->
          <div class="table-wrapper">
            <table
              class="table"
              ref="workersSum"
              v-show="activeTab === 2 && !showByReport"
            >
              <thead>
                <tr>
                  <th>Период</th>
                  <th>Работник</th>
                  <th>Общо планирано време (ч.)</th>
                  <th>Общо изработено време (ч.)</th>
                  <th v-if="isEarningsManager">
                    Общо заработки (лв.)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(user, i) in periodWorkers"
                  :key="`user-${i}`"
                  v-show="
                    $route.query.worker
                      ? user._id === $route.query.worker
                      : true
                  "
                >
                  <td>
                    {{ inquiry.fromDate | formatDate }} -
                    {{ inquiry.toDate | formatDate }}
                  </td>
                  <td>{{ user.name }}</td>
                  <td>
                    {{
                      user.totalPlannedDaysLoading
                        ? "зареждане..."
                        : user.totalPlannedDays
                    }}
                  </td>
                  <td>{{ user.totalTimeWorked }}</td>
                  <td v-if="isEarningsManager">
                    {{ user.totalZarabotki | formatDecimal }}
                  </td>
                </tr>

                <tr v-if="isInquiryMade && !totalWorkerItems">
                  <td
                    :colspan="getUser.permissions.isSuperAdmin ? 13 : 9"
                    class="td-center"
                  >
                    Няма добавени работници за избраните параметри.
                  </td>
                </tr>
                <tr class="sum-row" v-if="getUser.permissions.isSuperAdmin">
                  <td :colspan="getUser.permissions.isSuperAdmin ? 13 : 9">
                    Общо изразходено време:
                    <span>{{ totalWorkers.total }} ч.</span
                    >&nbsp;&nbsp;&nbsp;Общо заработки:
                    <span v-if="this.isEarningsManager">{{ totalWorkers.earnings | formatDecimal }} лв.</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="table"
              ref="workers"
              v-show="activeTab === 2 && showByReport"
            >
              <thead>
                <tr>
                  <th>Дата</th>
                  <th class="center">Дата на създаване</th>
                  <th class="print-hide">Работник</th>
                  <th>Фирма</th>
                  <th>Проект</th>
                  <th>Обект</th>
                  <th class="print-big-td">Дейност</th>
                  <th class="center">Изработено количество</th>
                  <th class="center">М.ед.</th>
                  <th
                    v-if="isEarningsManager"
                    class="print-hide center"
                    style="background-color: #a2bdf3"
                  >
                    Стойност на заработката
                  </th>
                  <template v-if="getUser.permissions.isSuperAdmin">
                    <th
                      class="print-hide center"
                      style="background-color: #a2bdf3"
                    >
                      М.ед.
                    </th>
                    <th class="print-hide center">Коефициент на работника</th>
                  </template>
                  <th v-if="isEarningsManager" class="print-hide center">
                    Заработка/лв
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="report in renderReports">
                  <template v-for="(a, ai) in report.activities">
                    <template v-for="(ar, ari) in a.rows">
                      <tr
                        v-for="worker in report.workers"
                        :key="`report-${report._id}-${ai}-${ari}-worker-${worker._id}`"
                        @click="goToReport(report._id)"
                        :class="{ 'tr-invalid': report.isInvalid }"
                      >
                        <td>
                          <span class="no-wrap"
                            >{{ report.date | formatDate }} г.</span
                          >
                        </td>
                        <td>
                          <span
                            class="no-wrap center"
                            v-if="
                              new Date(report.createdAt).getTime() >=
                              new Date('2022-12-01').getTime()
                            "
                            >{{ report.createdAt | formatDate }} г.</span
                          >
                        </td>
                        <td class="print-hide">{{ worker.name }}</td>
                        <td>{{ report.company.companyName }}</td>
                        <td>{{ report.project.projectName }}</td>
                        <td>{{ report.object.objectName }}</td>
                        <td class="print-big-td">{{ a.activityName }}</td>
                        <td class="center">
                          {{ (ar.producedQuantity || 0) | formatDecimal }}
                        </td>
                        <td class="center">
                          {{ a.activityUnit }}
                        </td>
                        <td
                          v-if="isEarningsManager"
                          class="print-hide center"
                          style="background-color: #dde4f1"
                        >
                          {{ a.earningsValue || "-" }}
                        </td>
                        <template v-if="getUser.permissions.isSuperAdmin">
                          <td
                            class="print-hide center"
                            style="background-color: #dde4f1"
                          >
                            лв/{{ a.activityUnit }}
                          </td>
                          <td class="print-hide center">
                            {{ worker.coefficient | formatDecimal }}
                          </td>
                        </template>
                        <td v-if="isEarningsManager" class="print-hide center">
                          {{
                            (
                              (ar.producedQuantity || 0) *
                              (worker.coefficient || 0) *
                              (a.earningsValue || 0)
                            ) | formatDecimal
                          }}
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
                <tr v-if="isInquiryMade && !totalWorkerItems">
                  <td
                    :colspan="getUser.permissions.isSuperAdmin ? 13 : 9"
                    class="td-center"
                  >
                    Няма добавени работници за избраните параметри.
                  </td>
                </tr>
                <tr class="sum-row" v-if="getUser.permissions.isSuperAdmin">
                  <td :colspan="getUser.permissions.isSuperAdmin ? 13 : 9">
                    Общо изразходено време:
                    <span>{{ totalWorkers.total }} ч.</span
                    >&nbsp;&nbsp;&nbsp;Общо заработки:
                    <span v-if="this.isEarningsManager">{{ totalWorkers.earnings | formatDecimal }} лв.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <section class="table-wrapper">
            <table
              class="table"
              ref="byObject"
              v-show="plannedVsReported && !showByReport"
            >
              <thead>
                <tr>
                  <template v-if="activeTab === 4">
                    <th>Фирми</th>
                    <th>Проекти</th>
                    <th>Обекти</th>
                  </template>
                  <th v-else>Фирми</th>
                  <th>Планирани часове/ЧД</th>
                  <th>Отчетени часове/ЧД</th>
                  <template v-if="workersInfo">
                    <th>Неотчетени дни - пълни</th>
                    <th>Неотчетени дни - непълни</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <template v-if="activeTab === 4">
                  <tr
                    v-for="r in reports.companies"
                    :key="`report-${r.company._id}-${r.project._id}-${r.object._id}`"
                    :class="{ 'tr-invalid': r.isInvalid }"
                  >
                    <td>{{ r.company.name }}</td>
                    <td>{{ r.project.name }}</td>
                    <td>{{ r.object.name }}</td>
                    <td>
                      {{ `${r.plannedHours} ч / ${r.plannedManDays} чд` }}
                    </td>
                    <td>
                      {{ `${r.reportedHours} ч / ${r.reportedManDays} чд` }}
                    </td>
                    <td v-if="workersInfo" colspan="2"></td>
                  </tr>
                </template>

                <template v-if="workersInfo">
                  <tr v-for="w in reports.workers" :key="`report-${w._id}`">
                    <td :colspan="activeTab === 4 ? 3 : 1">{{ w.name }}</td>
                    <td>
                      {{
                        w.planned
                          ? `${w.plannedHours} ч / ${w.plannedHours / 8} чд`
                          : ""
                      }}
                    </td>
                    <td>
                      <template v-if="w.reported">
                        {{ w.reportedHours }} ч / {{ (w.reportedHours / 8) | formatDecimal }} чд
                      </template>
                    </td>
                    <td>
                      <div
                        class="dates-wrap"
                        v-if="w.notReportedDatesFull.length"
                      >
                        <span>{{ w.notReportedDatesFull.length }} -</span>

                        <p
                          @click="goToReport(d.report)"
                          :class="{ link: d.report }"
                          v-for="(d, i) of w.notReportedDatesFull"
                          :key="`${i}-${d.date}`"
                        >
                          {{ format(new Date(d.date), "dd/MM") }}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div class="dates-wrap" v-if="w.notReportedDates.length">
                        <span>{{ w.notReportedDates.length }} -</span>

                        <p
                          @click="goToReport(d.report)"
                          :class="{ link: d.report }"
                          v-for="(d, i) of w.notReportedDates"
                          :key="`${i}-${d.date}`"
                        >
                          {{ format(new Date(d.date), "dd/MM") }} ({{
                            d.reportedHours
                          }}
                          ч.)
                        </p>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </template>
    <!-- MOBILE BUTTONS -->
    <footer class="modal-footer mobile" v-if="reports.length" ref="footer">
      <div class="btns mobile">
        <!-- UP -->
        <span
          class="new-content-data-item-toggle-circle mobile top"
          @click="scrollToTop()"
        >
          <span class="miv">f</span>
        </span>
        <!-- NEW Inquiry -->
        <span
          class="new-content-data-item-toggle-circle mobile"
          @click="resetInquiry()"
        >
          <span class="miv">L</span>
        </span>
        <!-- EXPORT IN EXCEL -->
        <span
          class="new-content-data-item-toggle-circle mobile excel"
          @click="exportToExcelFile()"
        >
          <span class="miv">E</span>
        </span>
      </div>
    </footer>
    <div class="loading-container" v-if="excelLoading">
      <img class="loading" src="@/assets/img/l_animated.svg" alt="loading" />
    </div>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import * as XLSX from "xlsx";
// import XLSX from "xlsx-js-style";
import { mapGetters } from "vuex";
// import WorktimeTag from "./shared/WorktimeTag";
export default {
  components: {
    Datepicker,
    // WorktimeTag,
  },
  mixins: [hours],
  data() {
    return {
      // Vars for select v-model
      format,
      company: "",
      project: "",
      object: "",
      part: "",
      reporter: "",
      worker: "",
      bg: bg,
      openTab: null,
      showByReport: false,
      excelLoading: false,
      zarabotkiPromises: [],
      periodWorkers: [],
      formatedFromDate: null,
      formatedToDate: null,
      activeTab: 3,
      datePeriod: "today",
      // DROPDOWNS
      openedDropdown: [false, false, false, false, false, false, false, false],
      // SEARCH
      searchCompanies: "",
      searchProjects: "",
      searchObjects: "",
      searchParts: "",
      searchReporters: "",
      searchWorkers: "",
      companies: [],
      projects: [],
      objects: [],
      parts: [],
      reporters: [],
      workers: [],
      reports: [],
      test: [],
      renderReports: [],
      totalActivities: 0,
      totalWorkers: {
        normal: 0,
        overtime: 0,
        holiday: 0,
        total: 0,
        normalTotal: 0,
        overtimeTotal: 0,
        holidayTotal: 0,
        earnings: 0,
      },
      totalActivityItems: 0,
      totalWorkerItems: 0,
      isInquiryMade: false,
      queryObject: {},
      activeProjects: true,
      showUnreported: false,
      noEarnings: false,
      showLogged: true,
      showNonLogged: true,
      inquiry: {
        fromDate: "",
        toDate: "",
        company: {
          _id: "",
          companyName: "",
        },
        project: {
          _id: "",
          projectName: "",
        },
        object: {
          _id: "",
          objectName: "",
        },
        part: {
          _id: "",
          partName: "",
        },
        reporter: {
          _id: "",
          name: "",
        },
        worker: {
          _id: "",
          name: "",
        },
        isInvalid: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getUser", "getLoading", "isEarningsManager"]),
    getLocation() {
      const loc = location.href.slice(location.origin.length);
      return encodeURIComponent(loc);
    },
    // planned Vs reported inquiry specific
    plannedVsReported() {
      return this.activeTab === 4 || this.activeTab === 5;
    },
    workersInfo() {
      return this.inquiry.object._id || this.activeTab === 5;
    },
  },
  watch: {
    "inquiry.fromDate"(to, from) {
      //eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      this.queryObject.fromDate = this.inquiry.fromDate.toISOString();
      this.formatedFromDate = format(
        new Date(this.inquiry.fromDate),
        "dd/MM/yyyy"
      );
    },
    "inquiry.toDate"(to, from) {
      //eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.toDate.setHours(23, 59, 59, 999);
      this.queryObject.toDate = this.inquiry.toDate.toISOString();
      this.formatedToDate = format(new Date(this.inquiry.toDate), "dd/MM/yyyy");
    },
  },
  methods: {
    largest(r) {
      // gets which is the largest so the table can be the size of the largest field and include all dates
      let reportsLength = r.reports ? r.reports.length : 0;
      let calendarsLength = r.calendars ? r.calendars.length : 0;
      let notReportedLength = r.notReported ? r.notReported.length : 0;

      let largest;

      if (reportsLength === calendarsLength) largest = r.reports;
      if (reportsLength > calendarsLength) largest = r.reports;
      if (calendarsLength > reportsLength) largest = r.calendars;
      if (largest && notReportedLength > largest.length)
        largest = r.notReported;

      return largest;
    },
    print() {
      window.print();
    },
    changeDatePeriod(p) {
      this.datePeriod = p;
      if (p === "today") {
        this.setDays(0);
      } else if (p === "yesterday") {
        this.setDays(-1);
      } else if (p === "current") {
        this.setDates(0, -1);
      } else if (p === "previous") {
        this.setDates(1, 0);
      }
      this.queryObject.period = p;
      this.$router.push({ query: this.queryObject }).catch(() => {});
    },
    setDates(from, to) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth() - from,
        1
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth() + to * -1,
        0
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },
    setDays(d) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },

    async exportToExcelFile() {
      this.excelLoading = true;

      await Promise.all(this.zarabotkiPromises);

      setTimeout(() => {
        const wscols = [
          { wpx: 80 },
          { wpx: 80 },
          { wpx: 150 },
          { wpx: 150 },
          { wpx: 150 },
          { wpx: 150 },
          { wpx: 150 },
          { wpx: 150 },
        ];
        let new_workbook = XLSX.utils.book_new();

        const config = { dateNF: "dd/mm/yyyy" };
        const wopts = { bookType: "xlsx", bookSST: true, compression: true };

        // Helper function to ensure value is a proper number for Excel
        const toNum = (num) => {
          if (num === null || num === undefined || num === '') return '';
          return Math.round(Number(num) * 100) / 100;
        };

        // Helper function to format decimals with comma separator (for display strings only)
        const formatDecimal = (num) => {
          if (num === null || num === undefined || num === '') return '';
          return Number(num).toFixed(2).replace('.', ',');
        };

        let reportsTable = [];

        if (!this.showUnreported) {
          let workersTable = [];

          for (let r of this.reports) {
            for (let a of r.activities) {
              for (let ar of a.rows) {
                for (let worker of r.workers) {
                  workersTable.push({
                    Дата: format(new Date(r.date), "dd/MM/yyyy"),
                    "Дата на създаване":
                      new Date(r.createdAt).getTime() >=
                      new Date("2022-12-01").getTime()
                        ? format(new Date(r.createdAt), "dd/MM/yyyy")
                        : "",
                    Работник: worker.name,
                    Фирма: r.company.companyName,
                    Проект: r.project.projectName,
                    Обект: r.object.objectName,
                    Дейност: a.activityName,
                    "Изработено количество": toNum(ar.producedQuantity || 0),
                    "М.ед.": a.activityUnit,

                    "Стойност на заработката": this.isEarningsManager
                      ? toNum(a.earningsValue) || "-"
                      : "",
                    "М.ед. ": this.getUser.permissions.isSuperAdmin
                      ? `лв/${a.activityUnit}`
                      : "",
                    "Коефициент на работника": this.getUser.permissions
                      .isSuperAdmin
                      ? toNum(worker.coefficient)
                      : "",
                    "Заработка/лв": this.isEarningsManager
                      ? toNum(
                          (ar.producedQuantity || 0) *
                          (worker.coefficient || 0) *
                          (a.earningsValue || 0)
                        )
                      : "",
                  });
                }
              }
            }
          }

          let workersSumTable = this.periodWorkers.map((user) => ({
            Период: `${format(
              new Date(this.inquiry.fromDate),
              "dd/MM/yyyy"
            )} - ${format(new Date(this.inquiry.toDate), "dd/MM/yyyy")}`,
            Работник: user.name,
            "Общо планирано време (ч.)": user.totalPlannedDays,
            "Общо изработено време (ч.)": user.totalTimeWorked,
            "Общо заработки (лв.)": this.isEarningsManager ? toNum(user.totalZarabotki) : '',
          }));

          // if (this.inquiry.worker._id) {
          //   let workersSheet = XLSX.utils.json_to_sheet(workersTable, config);
          //   let workersSumSheet = XLSX.utils.json_to_sheet(
          //     workersSumTable,
          //     config
          //   );
          //   if (this.getUser.permissions.isSuperAdmin) {
          //     XLSX.utils.sheet_add_aoa(
          //       workersSumSheet,
          //       [
          //         [
          //           "Общо изразходено време:",
          //           "",
          //           `${this.totalWorkers.total} ч.`,
          //           "Общо заработки:",
          //           `${this.totalWorkers.earnings.toFixed(2)} лв.`,
          //         ],
          //       ],
          //       { origin: -1 }
          //     );

          //     XLSX.utils.sheet_add_aoa(
          //       workersSheet,
          //       [
          //         [
          //           "Общо изразходено време:",
          //           "",
          //           `${this.totalWorkers.total} ч.`,
          //           "Общо заработки:",
          //           `${this.totalWorkers.earnings.toFixed(2)} лв.`,
          //         ],
          //       ],
          //       { origin: -1 }
          //     );
          //   }
          //   workersSheet["!cols"] = wscols;
          //   workersSumSheet["!cols"] = wscols;

          //   XLSX.utils.book_append_sheet(
          //     new_workbook,
          //     workersSheet,
          //     `Заработки по отчет`
          //   );
          //   XLSX.utils.book_append_sheet(
          //     new_workbook,
          //     workersSumSheet,
          //     `Общи заработки`
          //   );

          //   XLSX.writeFile(
          //     new_workbook,
          //     `Справка-за-${this.inquiry.worker.name}-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
          //   );
          //   return;
          // }
          reportsTable = this.reports.map((r) => ({
            Дата: format(new Date(r.date), "dd/MM/yyyy"),
            "Дата на създаване":
              new Date(r.createdAt).getTime() >=
              new Date("2022-12-01").getTime()
                ? format(new Date(r.createdAt), "dd/MM/yyyy")
                : "",
            Отчетник: r.createdBy.name,
            Фирма: r.company.companyName,
            Проект: r.project.projectName,
            Обект: r.object.objectName,
            "Отчетени хора": r.workers.length,
            НРВ: r.calculated.normal,
            ИРВ: r.calculated.overtime,
            "ИРВ 2": r.calculated.holiday,
            "Отчетени части": r.partsList ? r.partsList.length : "",
            "Отчетени дейности": r.activities ? r.activities.length : "",
            АКТУВАНО: r.isLogged ? "Актувано" : "",
          }));

          let activitiesTable = [];
          for (let r of this.reports) {
            for (let a of r.activities) {
              for (let ro of a.rows) {
                activitiesTable.push({
                  Дата: format(new Date(r.date), "dd/MM/yyyy"),
                  "Дата на създаване":
                    new Date(r.createdAt).getTime() >=
                    new Date("2022-12-01").getTime()
                      ? format(new Date(r.createdAt), "dd/MM/yyyy")
                      : "",
                  Отчетник: r.createdBy.name,
                  Фирма: r.company.companyName,
                  Проект: r.project.projectName,
                  Обект: r.object.objectName,
                  Част: ro.part ? ro.part.partName : "",
                  Коментар: ro.partComment,
                  Дейност: a.activityName,
                  Доставка: ro.supplier,
                  "Коментар ": ro.supplierComment,
                  Количество: toNum(ro.quantity),
                  "М.ед.": a.activityUnit,
                  "Сума/лв":
                    this.getUser.permissions.isSuperAdmin ||
                    this.getUser.permissions.isAdmin ||
                    this.getUser.permissions.isHR
                      ? toNum(+ro.price * +ro.quantity)
                      : "",
                  "АКТУВАНА ДЕЙНОСТ": r.isLogged ? "Актувано" : "",
                });
              }
            }
          }

          let reportSheet = XLSX.utils.json_to_sheet(reportsTable, config);
          let activitiesSheet = XLSX.utils.json_to_sheet(
            activitiesTable,
            config
          );
          let workersSheet = XLSX.utils.json_to_sheet(workersTable, config);
          let workersSumSheet = XLSX.utils.json_to_sheet(
            workersSumTable,
            config
          );

          if (this.getUser.permissions.isSuperAdmin) {
            XLSX.utils.sheet_add_aoa(
              workersSumSheet,
              [
                [
                  "Общо изразходено време:",
                  "",
                  `${this.totalWorkers.total} ч.`,
                  "Общо заработки:",
                  this.isEarningsManager ? `${formatDecimal(this.totalWorkers.earnings)} лв.` : '',
                ],
              ],
              { origin: -1 }
            );

            XLSX.utils.sheet_add_aoa(
              workersSheet,
              [
                [
                  "Общо изразходено време:",
                  "",
                  `${this.totalWorkers.total} ч.`,
                  "Общо заработки:",
                  this.isEarningsManager ? `${formatDecimal(this.totalWorkers.earnings)} лв.` : '',
                ],
              ],
              { origin: -1 }
            );

            XLSX.utils.sheet_add_aoa(
              activitiesSheet,
              [
                [
                  "Обща сума за избраните дейности:",
                  "",
                  `${formatDecimal(this.totalActivities)} лв.`,
                ],
              ],
              { origin: -1 }
            );
          }

          reportSheet["!cols"] = wscols;
          activitiesSheet["!cols"] = wscols;
          workersSheet["!cols"] = wscols;
          workersSumSheet["!cols"] = wscols;

          XLSX.utils.book_append_sheet(new_workbook, reportSheet, `Отчети`);

          XLSX.utils.book_append_sheet(
            new_workbook,
            activitiesSheet,
            `Дейности`
          );
          XLSX.utils.book_append_sheet(
            new_workbook,
            workersSheet,
            `Заработки по отчет`
          );
          XLSX.utils.book_append_sheet(
            new_workbook,
            workersSumSheet,
            `Общи заработки`
          );

          XLSX.writeFile(
            new_workbook,
            `Справка-${this.formatedFromDate}-${this.formatedToDate}.xlsx`,
            wopts
          );
        } else {
          // unreported Excel
          for (let r of this.reports) {
            for (let j in this.largest(r)) {
              reportsTable.push({
                Служител: j == 0 ? r.name : "",
                "Планирани дни брой":
                  j == 0 ? (r.calendars ? r.calendars.length : 0) : "",
                "Планирани дни/обекти":
                  r.calendars && r.calendars[j]
                    ? `${r.calendars[j].date} ${
                        r.calendars[j].object
                          ? `- ${r.calendars[j].object.map(
                              (s, i) => (i !== 0 ? "🔵" : "") + s
                            )}`
                          : ""
                      }`
                    : "",
                "Отчетени дни брой":
                  j == 0 ? (r.reports ? r.reports.length : 0) : "",
                "Отчетени дни/обекти":
                  r.reports && r.reports[j]
                    ? `${r.reports[j].date} ${
                        r.reports[j].object
                          ? `- ${r.reports[j].object.map(
                              (s, i) => (i !== 0 ? "🔵" : "") + s
                            )}`
                          : ""
                      }`
                    : "",
                Разлика: j == 0 ? r.difference : "",
                "Липсващи отчети":
                  r.notReported && r.notReported[j]
                    ? `${r.notReported[j].date} ${
                        r.notReported[j].object
                          ? `- ${r.notReported[j].object.map(
                              (s, i) => (i !== 0 ? "🔵" : "") + s
                            )}`
                          : ""
                      }`
                    : "",
              });
            }
          }

          let reportSheet = XLSX.utils.json_to_sheet(reportsTable, config);
          reportSheet["!cols"] = wscols;

          XLSX.utils.book_append_sheet(new_workbook, reportSheet, `Отчети`);
          XLSX.writeFile(
            new_workbook,
            `Справка-${this.formatedFromDate}-${this.formatedToDate}.xlsx`,
            wopts
          );
        }

        this.excelLoading = false;
      }, 3000);

      //  XLSX.writeFile(
      //     new_workbook,
      //     `Справка-за-${this.inquiry.worker.name}-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
      //   );

      // const wscols = [
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      //   { wpx: 100 },
      // ];

      // const config = { dateNF: "dd/mm/yyyy" };
      // // Convert Table to Worksheet

      // if (!this.inquiry.worker._id) {
      //   const reportsWorksheet = XLSX.utils.table_to_sheet(
      //     this.$refs["reportsTable"],
      //     config
      //   );
      //   const new_workbook = XLSX.utils.book_new();

      //   // Define New Workbook
      //   reportsWorksheet["!cols"] = wscols;

      //   // Append Worksheet
      //   XLSX.utils.book_append_sheet(new_workbook, reportsWorksheet, "Отчети");

      //   if (this.showUnreported) {
      //     let style = { font: { bold: true } };

      //     let validLetters = ["A1", "B1", "C1", "D1", "E1", "F1", "G1"];

      //     for (const key in reportsWorksheet) {
      //       if (validLetters.includes(key)) reportsWorksheet[key].s = style;
      //     }
      //   }

      //   if (!this.showUnreported) {
      //     // Convert Table to Worksheet
      //     const materialsWorksheet = XLSX.utils.table_to_sheet(
      //       this.$refs["materials"],
      //       config
      //     );
      //     const activitiesWorksheet = XLSX.utils.table_to_sheet(
      //       this.$refs["activities"],
      //       config
      //     );
      //     const workersWorksheet = XLSX.utils.table_to_sheet(
      //       this.$refs["workers"],
      //       config
      //     );
      //     const AllWorkersWorksheet = XLSX.utils.table_to_sheet(
      //       this.$refs["workersSum"],
      //       config
      //     );

      //     // Define New Workbook
      //     materialsWorksheet["!cols"] = wscols;
      //     activitiesWorksheet["!cols"] = wscols;
      //     workersWorksheet["!cols"] = wscols;
      //     AllWorkersWorksheet["!cols"] = wscols;

      //     // Append Worksheet
      //     XLSX.utils.book_append_sheet(
      //       new_workbook,
      //       materialsWorksheet,
      //       "Материали"
      //     );
      //     XLSX.utils.book_append_sheet(
      //       new_workbook,
      //       activitiesWorksheet,
      //       "Дейности"
      //     );
      //     XLSX.utils.book_append_sheet(
      //       new_workbook,
      //       workersWorksheet,
      //       "Заработки по отчет"
      //     );
      //     XLSX.utils.book_append_sheet(
      //       new_workbook,
      //       AllWorkersWorksheet,
      //       "Общи заработки"
      //     );
      //   }
      //   // Save File
      //   XLSX.writeFile(
      //     new_workbook,
      //     `Справка-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
      //   );
      // } else {
      //   const workersWorksheet = XLSX.utils.table_to_sheet(
      //     this.$refs["workers"],
      //     config
      //   );
      //   const AllWorkersWorksheet = XLSX.utils.table_to_sheet(
      //     this.$refs["workersSum"],
      //     config
      //   );
      //   // Define New Workbook
      //   const new_workbook = XLSX.utils.book_new();

      //   workersWorksheet["!cols"] = wscols;
      //   AllWorkersWorksheet["!cols"] = wscols;

      //   // Append Worksheet
      //   XLSX.utils.book_append_sheet(
      //     new_workbook,
      //     workersWorksheet,
      //     `Заработки по отчет`
      //   );
      //   XLSX.utils.book_append_sheet(
      //     new_workbook,
      //     AllWorkersWorksheet,
      //     `Общи заработки`
      //   );
      //   // Save File

      //   XLSX.writeFile(
      //     new_workbook,
      //     `Справка-за-${this.inquiry.worker.name}-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
      //   );
      // }
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    selectSwitch(type) {
      if (type) this.queryObject.workersTableType = type;
      else delete this.queryObject.workersTableType;

      this.$router.push({ query: this.queryObject }).catch(() => {});
    },
    selectTab(num) {
      if (this.activeTab === num) return;
      this.isInquiryMade = false;
      // if (this.inquiry.worker._id) {
      //   this.activeTab = 2;
      // } else
      this.activeTab = num;
      this.queryObject.tab = this.activeTab;
      if (this.$route.query.workersTableType)
        (this.queryObject.workersTableType = true), (this.showByReport = true);
      this.$router
        .push({ query: this.queryObject })
        .then(() => this.getInquiry())
        .catch(() => {});
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredProjects() {
      if (this.projects.length) {
        return this.projects.filter((p) => {
          return p.projectName
            .toLowerCase()
            .includes(this.searchProjects.toLowerCase());
        });
      }
    },
    filteredObjects() {
      if (this.objects.length) {
        return this.objects.filter((o) => {
          return o.objectName
            .toLowerCase()
            .includes(this.searchObjects.toLowerCase());
        });
      }
    },
    filteredParts() {
      if (this.parts.length) {
        return this.parts.filter((p) => {
          return p.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    filteredReporters() {
      if (this.reporters.length) {
        return this.reporters.filter((r) => {
          return r.name
            .toLowerCase()
            .includes(this.searchReporters.toLowerCase());
        });
      }
    },
    filteredWorkers() {
      if (this.workers.length) {
        return this.workers.filter((w) => {
          return w.name
            .toLowerCase()
            .includes(this.searchWorkers.toLowerCase());
        });
      }
    },
    // RESETS
    resetSelectedCompany() {
      this.inquiry.company = {
        _id: "",
        companyName: "",
      };
      this.company = "";
      delete this.queryObject.company;
      delete this.queryObject.companyName;
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.inquiry.project = {
        _id: "",
        projectName: "",
      };
      this.project = "";
      delete this.queryObject.project;
      delete this.queryObject.projectName;
      this.resetSelectedObject();
    },
    resetSelectedObject() {
      this.inquiry.object = {
        _id: "",
        objectName: "",
      };
      this.object = "";
      delete this.queryObject.object;
      delete this.queryObject.objectName;
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.resetReports();
      this.inquiry.part = {
        _id: "",
        partName: "",
      };
      this.part = "";
      delete this.queryObject.part;
      delete this.queryObject.partName;
    },
    resetSelectedReporter() {
      this.resetReports();
      this.inquiry.reporter = {
        _id: "",
        name: "",
      };
      this.reporter = "";
      delete this.queryObject.reporter;
      delete this.queryObject.reporterName;
    },
    resetSelectedWorker() {
      this.resetReports();
      this.inquiry.worker = {
        _id: "",
        name: "",
      };
      this.reporter = "";
      delete this.queryObject.worker;
      delete this.queryObject.workerName;
    },
    resetInquiry() {
      this.reports = [];
      this.renderReports = [];
      this.isInquiryMade = false;
      this.resetSelectedCompany();
      if (
        this.getUser.permissions.isSuperAdmin ||
        this.getUser.permissions.isAdmin
      ) {
        this.resetSelectedReporter();
      }
      this.resetSelectedWorker();
      this.changeDatePeriod("today");
    },
    resetReports() {
      this.reports = [];
      this.renderReports = [];
      this.isInquiryMade = false;
    },
    // SELECTS
    selectCompany(c) {
      this.resetReports();
      this.inquiry.company = c;
      this.queryObject.company = c._id;
      this.queryObject.companyName = c.companyName;
    },
    selectProject(p) {
      this.resetReports();
      this.inquiry.project = p;
      this.queryObject.project = p._id;
      this.queryObject.projectName = p.projectName;
    },
    selectObject(o) {
      this.resetReports();
      this.inquiry.object = o;
      this.queryObject.object = o._id;
      this.queryObject.objectName = o.objectName;
    },
    selectPart(p) {
      this.resetReports();
      this.inquiry.part = p;
      this.queryObject.part = p._id;
      this.queryObject.partName = p.partName;
    },
    selectReporter(r) {
      this.resetReports();
      this.inquiry.reporter = r;
      this.queryObject.reporter = r._id;
      this.queryObject.reporterName = r.name;
    },
    selectWorker(w) {
      this.resetReports();
      this.inquiry.worker = w;
      this.queryObject.worker = w._id;
      this.queryObject.workerName = w.name;
    },
    selectInvalid() {
      this.resetReports();
      this.queryObject.isInvalid = this.inquiry.isInvalid;

      if (this.inquiry.isInvalid) {
        if (this.showUnreported) {
          this.showUnreported = false;
          this.selectShowUnreported();
        }
        if (this.noEarnings) {
          this.noEarnings = false;
          this.selectNoEarnings();
        }
      }
    },
    selectActiveProjects() {
      this.resetReports();
      this.resetSelectedCompany();
      this.queryObject.active = this.activeProjects;

      if (this.activeProjects) {
        if (this.showUnreported) {
          this.showUnreported = false;
          this.selectShowUnreported();
        }
      }
    },
    selectShowUnreported() {
      this.resetReports();
      this.queryObject.unreported = this.showUnreported;

      if (this.showUnreported) {
        this.activeProjects = false;
        this.selectActiveProjects();
        this.noEarnings = false;
        this.selectNoEarnings();
        this.inquiry.isInvalid = false;
        this.selectInvalid();
      }
    },
    selectNoEarnings() {
      this.resetReports();
      this.queryObject.noEarnings = this.noEarnings;

      if (this.noEarnings) {
        this.showUnreported = false;
        this.selectShowUnreported();
        this.inquiry.isInvalid = false;
        this.selectInvalid();
      }
    },
    async updateReport(report) {
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/report/log-all`;
        await this.$http.put(url, {
          reports: [{ _id: report._id, isLogged: report.isLogged }],
        });
      } catch (error) {
        console.log(error);
        report.isLogged = !report.isLogged;
        this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
      }
    },
    async updateReports(reports) {
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/report/log-all`;
        await this.$http.put(url, { reports });
      } catch (error) {
        console.error("Error updating reports:", error);
      }
    },
    async toggleLogged(logAll) {
      let text = logAll
        ? "актувате всички"
        : "премахнете актуването на всички актувани";

      if (!confirm(`Ще ${text} отчети в избраната справка. Сигурни ли сте?`))
        return;

      try {
        const updatedReports = this.reports.map((r) => ({
          ...r,
          isLogged: logAll,
        }));

        await this.updateReports(updatedReports);

        this.showLogged = true;
        this.showNonLogged = true;
        this.getInquiry();
      } catch (error) {
        console.error("Error updating reports:", error);
      }
    },
    getDaysArray(start, end) {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push({
          date: `${dt.getFullYear()}/${("0" + (dt.getMonth() + 1)).slice(
            -2
          )}/${("0" + dt.getDate()).slice(-2)}`,
          object: null,
        });
      }
      return arr;
    },
    getUnreportedData(array) {
      const dates = this.getDaysArray(
        this.inquiry.fromDate,
        this.inquiry.toDate
      );

      for (let r of array) {
        const promises = [];

        for (let x of ["report", "restDay", "calendar", "otpusk"]) {
          promises.push(
            new Promise((res, rej) => {
              let y = x;
              if (x === "restDay") y = "calendar";
              let url = `${process.env.VUE_APP_BASE_URI}/${y}/inquiry`;

              url += `/${this.inquiry.fromDate.toISOString()}`;
              url += `/${this.inquiry.toDate.toISOString()}`;
              url += `/${r._id}`;
              if (x === "restDay") url += "?restDays=true";

              this.$http
                .get(url)
                .then((response) => {
                  if (response.data.length) {
                    if (x === "otpusk") {
                      let otpusks = [];

                      for (let o of response.data) {
                        otpusks = [
                          ...new Set([
                            ...otpusks,
                            ...this.getDaysArray(o.dateFrom, o.dateTo),
                          ]),
                        ];
                      }

                      this.$set(r, "otpusks", otpusks);
                    } else {
                      let sortedDates = [
                        ...response.data.map((elem) => ({
                          date: elem._id,
                          object: elem.object.length
                            ? elem.object.map((o) => o.objectName)
                            : null,
                        })),
                      ].sort((a, b) => a.date.localeCompare(b.date));

                      this.$set(r, `${x}s`, sortedDates);
                    }
                  }
                  res();
                })
                .catch((err) => rej(err));
            })
          );
        }

        Promise.all(promises).then(() => {
          let difference = 0;
          if (r.reports) difference += r.reports.length;
          if (r.calendars) difference -= r.calendars.length;
          if (difference > 0) difference = `+${difference}`;
          this.$set(r, "difference", difference);

          let notReported = dates.slice();

          // reseting the object value for all the dates
          notReported = notReported.map((elem) => ({
            date: elem.date,
            object: elem.object ? elem.object : null,
          }));

          for (let x of ["reports", "otpusks", "restDays"]) {
            if (r[x]) {
              let reportedDays = [];
              let restDaysArray = [];
              let otpusksArray = [];
              let missedObjects = [];

              // if users has been planed for 2 object in 1 day but has reported only 1 object then add the other object to the notReported
              if (r.calendars && r.reports) {
                r.calendars.map((cl) => {
                  r.reports.map((rp) => {
                    if (
                      cl.date === rp.date &&
                      cl.object.filter((ca) => !rp.object.includes(ca)).length
                    ) {
                      missedObjects.push({
                        date: cl.date,
                        object: cl.object.filter(
                          (ca) => !rp.object.includes(ca)
                        ),
                      });
                    }
                  });
                });
              }
              if (r.reports) {
                reportedDays = r.reports.map((t) => {
                  return t.date;
                });
              }
              if (r.restDays) {
                restDaysArray = r.restDays.map((t) => {
                  return t.date;
                });
              }
              if (r.otpusks) {
                otpusksArray = r.otpusks.map((t) => {
                  return t.date;
                });
              }

              notReported = notReported.filter((d) => {
                return (
                  !reportedDays.includes(d.date) &&
                  !restDaysArray.includes(d.date) &&
                  !otpusksArray.includes(d.date)
                );
              });

              notReported.push(...missedObjects);
              notReported.sort((a, b) => a.date.localeCompare(b.date));
            }
          }

          // sets the object to the date
          if (r.calendars) {
            r.calendars.forEach((cd) => {
              notReported.forEach((d) => {
                if (cd.date === d.date && cd.object && !d.object)
                  d.object = cd.object;
              });
            });
          }

          this.$set(r, "notReported", notReported);

          this.$set(r, "largest", this.largest(r));

          this.$set(r, "loaded", true);
        });
      }
    },
    calculateData(array) {
      if (!array.length) return;
      const totals = {
        activities: 0,
      };
      let sum = {
        normal: 0,
        overtime: 0,
        holiday: 0,
        total: 0,
        normalTotal: 0,
        overtimeTotal: 0,
        holidayTotal: 0,
        earnings: 0,
      };
      this.totalActivityItems = 0;
      this.totalWorkerItems = 0;

      array.forEach((r) => {
        let parts = [];

        if (r.activities) {
          for (let y of r.activities) {
            this.totalActivityItems++;
            for (let ro of y.rows) {
              totals.activities += Math.round((+ro.quantity * +ro.price) * 100) / 100;

              if (!this.inquiry.worker._id) {
                if (ro.part) {
                  if (parts.indexOf(ro.part.partName) === -1) {
                    parts.push(ro.part.partName);
                  }
                }
              }
            }
          }
        }

        if (!this.inquiry.worker._id) {
          this.$set(r, "partsList", parts);
        }

        if (r.workers) {
          this.$set(r, "calculated", {
            normal: 0,
            overtime: 0,
            holiday: 0,
            total: 0,
          });
          r.workers.forEach((w) => {
            this.totalWorkerItems++;
            const calculated = this.calculateHours(
              r.date,
              w.startHour,
              w.endHour
            );

            sum.normal += calculated.normal;
            sum.holiday += calculated.holiday;
            sum.overtime += calculated.overtime;
            sum.total += calculated.total;
            const hourlyWage = w.wage ? w.wage / 22 / 8 : 0;
            sum.normalTotal += calculated.normal * hourlyWage;
            sum.overtimeTotal += calculated.overtime * hourlyWage;
            sum.holidayTotal += calculated.holiday * hourlyWage;

            this.$set(w, "calculated", calculated);

            this.$set(
              r.calculated,
              "holiday",
              r.calculated.holiday + calculated.holiday
            );
            this.$set(
              r.calculated,
              "normal",
              r.calculated.normal + calculated.normal
            );
            this.$set(
              r.calculated,
              "overtime",
              r.calculated.overtime + calculated.overtime
            );
          });
        }
      });

      this.totalActivities = totals.activities;
      this.totalWorkers = sum;
      this.getWorkersProducedQuantity(array);
    },
    async getAllZarabotkiData(wo, array) {
      let sum = { totalTime: 0, totalZarabotki: 0 };
      const baseUrl = process.env.VUE_APP_BASE_URI;
      const { fromDate, toDate } = this.inquiry;

      const url = `${baseUrl}/calendar/inquiry/${fromDate.toISOString()}/${toDate.toISOString()}/${
        wo._id
      }`;

      try {
        this.$set(wo, "totalPlannedDaysLoading", true);
        const response = await this.$http.get(url);
        this.$set(wo, "totalPlannedDays", (response.data.length || 0) * 8);
        this.$set(wo, "totalPlannedDaysLoading", false);
      } catch (err) {
        console.log(err);
      }

      if (!array.length) return;

      array.forEach((report) => {
        const worker = report.workers.find((w) => w._id === wo._id);
        if (!worker) return;

        report.activities.forEach((activity) => {
          activity.rows.forEach((ar) => {
            sum.totalZarabotki += Math.round(
              (ar.producedQuantity || 0) *
              (worker.coefficient || 0) *
              (activity.earningsValue || 0) * 100
            ) / 100;
          });
        });

        sum.totalTime += this.calculateHours(
          report.date,
          worker.startHour,
          worker.endHour
        ).total;
      });

      this.$set(wo, "totalTimeWorked", sum.totalTime);
      this.$set(wo, "totalZarabotki", Math.round(sum.totalZarabotki * 100) / 100);
    },
    getWorkersProducedQuantity(array) {
      let total = 0;
      this.periodWorkers = [];

      array.forEach((report) => {
        const workerCount = report.workersLength || 0;

        if (workerCount) {
          if (report.activities && report.activities.length > 0) {
            report.activities.forEach((activity) => {
              activity.rows.forEach((row) => {
                const producedQuantity = row.quantity / workerCount;
                this.$set(row, "producedQuantity", producedQuantity);

                report.workers.forEach((worker) => {
                  total += Math.round(
                    (producedQuantity || 0) *
                    (worker.coefficient || 0) *
                    (activity.earningsValue || 0) * 100
                  ) / 100;
                });
              });
            });
          }

          report.workers.forEach((worker) => {
            if (
              this.$route.query.worker
                ? worker._id === this.$route.query.worker
                : true
            ) {
              this.periodWorkers.push(worker);
            }
          });
        }
      });

      this.$set(this.totalWorkers, "earnings", total);
      this.periodWorkers = [
        ...new Map(this.periodWorkers.map((item) => [item._id, item])).values(),
      ];
      if (!this.showUnreported) {
        this.zarabotkiPromises = this.periodWorkers
          .filter((x) => !x.totalTime)
          .map((x) => this.getAllZarabotkiData(x, this.reports));
      }
    },
    // REQUESTS
    getCompanies() {
      let url = "";
      if (this.getUser.permissions.isAdmin) {
        url = `${process.env.VUE_APP_BASE_URI}/company/${
          this.activeProjects ? "active" : "inactive"
        }`;
      } else if (this.getUser.permissions.isReporter) {
        url = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${this.getUser._id}`;
      } else {
        this.$snotify.error("Нямате достатъчно права!");
      }

      return this.$http
        .get(url)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => console.log(error));
    },
    getProjects() {
      this.projects = [];
      if (this.inquiry.company._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/project-names/${
            this.inquiry.company._id
          }?active=${this.activeProjects ? "true" : "false"}`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.inquiry.company._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error("Нямате достатъчно права!");
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.projects = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getObjects() {
      this.objects = [];
      if (this.inquiry.project._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/object-names/${
            this.inquiry.company._id
          }/${this.inquiry.project._id}?active=${
            this.activeProjects ? "true" : "false"
          }`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.inquiry.company._id}/${this.inquiry.project._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error("Нямате достатъчно права!");
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.objects = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getParts() {
      this.parts = [];
      if (this.inquiry.object._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/company/part-names/${this.inquiry.company._id}/${this.inquiry.project._id}/${this.inquiry.object._id}`;
        return this.$http
          .get(url)
          .then((response) => {
            this.parts = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getReporters() {
      this.reporters = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/reporters?active=true`)
        .then((response) => {
          this.reporters = response.data;
        });
    },
    getWorkers() {
      this.workers = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/workers?active=true`)
        .then((response) => {
          this.workers = response.data;
        });
    },
    // if there are queries, load the existing parameters and assign them to the empty queryObject
    // TODO: refactor
    loadQueries(query) {
      if (Object.keys(query).length) {
        if (query.fromDate) {
          this.inquiry.fromDate = new Date(query.fromDate);
          this.queryObject.fromDate = query.fromDate;
        }
        if (query.toDate) {
          this.inquiry.toDate = new Date(query.toDate);
          this.queryObject.toDate = query.toDate;
        }
        if (query.company) {
          this.inquiry.company._id = query.company;
          this.queryObject.company = query.company;
        }
        if (query.companyName) {
          this.inquiry.company.companyName = query.companyName;
          this.queryObject.companyName = query.companyName;
        }
        if (query.project) {
          this.inquiry.project._id = query.project;
          this.queryObject.project = query.project;
        }
        if (query.projectName) {
          this.inquiry.project.projectName = query.projectName;
          this.queryObject.projectName = query.projectName;
        }
        if (query.object) {
          this.inquiry.object._id = query.object;
          this.queryObject.object = query.object;
        }
        if (query.objectName) {
          this.inquiry.object.objectName = query.objectName;
          this.queryObject.objectName = query.objectName;
        }
        if (query.part) {
          this.inquiry.part._id = query.part;
          this.queryObject.part = query.part;
        }
        if (query.partName) {
          this.inquiry.part.partName = query.partName;
          this.queryObject.partName = query.partName;
        }
        if (query.reporter) {
          this.inquiry.reporter._id = query.reporter;
          this.queryObject.reporter = query.reporter;
        }
        if (query.reporterName) {
          this.inquiry.reporter.name = query.reporterName;
          this.queryObject.reporterName = query.reporterName;
        }
        if (query.worker) {
          this.inquiry.worker._id = query.worker;
          this.queryObject.worker = query.worker;
        }
        if (query.workerName) {
          this.inquiry.worker.name = query.workerName;
          this.queryObject.workerName = query.workerName;
        }
        if (query.tab) {
          this.selectTab(+query.tab);
        }
        if (query.period) {
          this.datePeriod = query.period;
          this.queryObject.period = query.period;
        }
        if (query.isInvalid) {
          const isInvalid = query.isInvalid == "true" ? true : false;
          this.inquiry.isInvalid = isInvalid;
          this.queryObject.isInvalid = isInvalid;
        }
        if (query.active) {
          const active = query.active == "true" ? true : false;
          this.activeProjects = active;
          this.queryObject.active = active;
        }
        if (query.noEarnings) {
          const noEarnings = query.noEarnings == "true" ? true : false;
          this.noEarnings = noEarnings;
          this.queryObject.noEarnings = noEarnings;
        }
        if (query.unreported) {
          const unreported = query.unreported == "true" ? true : false;
          this.showUnreported = unreported;
          this.queryObject.unreported = unreported;
        }

        this.getInquiry();
      }
    },
    handleScroll() {
      let el = this.$refs.reportsTable;
      if (this.activeTab === 3) {
        el = this.$refs.reportsTable;
      }
      if (this.activeTab === 1) {
        el = this.$refs.activities;
      }
      if (this.activeTab === 2 && !this.showByReport) {
        el = this.$refs.workersSum;
      }
      if (this.activeTab === 2 && this.showByReport) {
        el = this.$refs.workers;
      }

      if (
        !this.plannedVsReported &&
        this.renderReports.length !== this.reports.length &&
        el &&
        el.getBoundingClientRect().bottom <
          window.innerHeight + window.innerHeight / 5
      ) {
        this.renderMoreReports();
      }
    },
    renderMoreReports() {
      const batchSize = 20;
      const start = this.renderReports.length;
      const nextReports = this.reports.slice(start, start + batchSize);

      if (!nextReports.length) {
        this.$store.dispatch("stopLoading");
        document.body.classList.remove("stop-scrolling");
        return;
      }

      this.renderReports.push(...nextReports);
      this.getRenderedReportsData(this.renderReports);
    },
    async getRenderedReportsData(reports) {
      if (!reports.length) return;
      // stops the scroll so we wait until the current reports are done
      document.body.classList.add("stop-scrolling");

      await Promise.all([
        this.showUnreported
          ? this.getUnreportedData(reports)
          : Promise.resolve(),
        // !this.noEarnings ? this.calculateData(reports) : Promise.resolve(),
      ]);

      this.$store.dispatch("stopLoading");
      document.body.classList.remove("stop-scrolling");
    },
    async getInquiry() {
      this.$store.dispatch("startLoading");
      this.$router.push({ query: this.queryObject }).catch(() => {});
      this.isInquiryMade = true;
      this.renderReports = [];
      this.reports = [];

      let baseUrl = process.env.VUE_APP_BASE_URI;
      let url = "";

      if (!this.noEarnings && !this.showUnreported) {
        if (this.plannedVsReported) {
          url = `${baseUrl}/report/inquiry/planned-vs-reported`;
        } else url = `${baseUrl}/report/inquiry/inquiry`;
      } else if (this.noEarnings) {
        url = `${baseUrl}/company/missing-earnings`;
      } else if (this.showUnreported) {
        url = `${baseUrl}/auth/users/names/active`;
      }

      const params = new URLSearchParams({
        company: this.inquiry.company._id || 0,
        project: this.inquiry.project._id || 0,
        object: this.inquiry.object._id || 0,
        part: this.inquiry.part._id || 0,
        reporter: this.inquiry.reporter._id || 0,
        worker: this.inquiry.worker._id || 0,
        from: this.inquiry.fromDate.toISOString(),
        to: this.inquiry.toDate.toISOString(),
        invalid: this.inquiry.isInvalid,
        active: this.activeProjects,
        showLogged: this.showLogged,
        showNonLogged: this.showNonLogged,
        onlyUsers: this.activeTab === 5,
      });

      url += `?${params.toString()}`;

      try {
        const response = await this.$http.get(url);
        this.reports = response.data;

        if (!this.plannedVsReported) {
          if (!this.noEarnings) this.calculateData(this.reports);

          this.renderMoreReports();
        }
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        this.$store.dispatch("stopLoading");
      }
    },
    scrollToTop() {
      this.$refs["top"].scrollIntoView({ behavior: "smooth" });
    },
    goToReport(id) {
      if (!id) return;
      this.$router.push(`/reports/edit/${id}?back=true`);
    },
  },
  mounted() {
    this.openTab = this.$route.query.tab;
    window.addEventListener("scroll", this.handleScroll);

    // this.getCompanies();
    // this.getReporters();
    // this.getWorkers();
    this.setDays(0);
    this.loadQueries(this.$route.query);

    if (
      !this.getUser.permissions.isAdmin &&
      this.getUser.permissions.isReporter
    ) {
      this.selectReporter({
        name: this.getUser.name,
        _id: this.getUser._id,
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.dates-wrap {
  align-items: center;
  display: flex;
  gap: 5px;

  p {
    display: flex;

    &:not(:last-child)::after {
      content: ",";
    }
  }
}
.loading-container {
  background: rgb(0, 106, 210, 0.5);
  height: 100%;
  position: fixed;
  user-select: none;
  width: 100%;
  z-index: 100;
}
.loading-container img {
  position: relative;
  width: 15%;
  z-index: 1000;
}
.inquiry {
  padding: 10px 40px;
}
.switch-wrapper {
  align-items: center;
  display: flex;
  /* padding: 15px 0 5px 25px; */
}
.switch {
  margin: 0 10px;
}
.slider {
  background-color: #0078d7;
}
input:checked + .slider {
  background-color: #083f75;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
  text-decoration: underline;
}
.inquiry-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.inquiry-header-controlls {
  align-items: center;
  display: flex;
}
.inquiry-pre-datepicker-text {
  color: #373737;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  margin-right: 20px;
}
.inquiry-datepicker {
  border-radius: 4px;
  display: flex;
  position: relative;
  width: 330px;
  padding: 10px 0;
}
.inquiry-datepicker .new-input-wrapper {
  background-color: #ccd1e3;
  margin: 0;
  width: 50%;
}
.inquiry-datepicker .new-input-wrapper:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.inquiry-datepicker .new-input-wrapper:nth-child(2) {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.inquiry-datepicker .new-input {
  background-color: transparent;
  margin: 0;
}
.inquiry-datepicker .new-input input {
  background-color: transparent;
  border: 1px solid #ccd1e3;
  height: 36px;
  cursor: pointer;
}
.inquiry-datepicker .new-input input:focus {
  background-color: #f4f4f4;
  border: 1px solid #0099ff;
}
/* .inquiry-datepicker .datepicker-dropdown { */
/* background-color: #ccd1e3; */
/* } */
.inquiry-header-controlls .btns {
  align-items: center;
}
.inquiry-filters {
  background-color: #ccd1e3;
  border-radius: 4px;
  margin-top: 10px;
  padding: 25px 25px 15px;
}
.inquiry-filters-inputs {
  display: flex;
}
.inquiry-filters-inputs .new-input-wrapper:last-child {
  margin-right: 0;
}
.inquiry-filters-btns {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.inquiry-filters-btns .checkboxes {
  display: flex;
}
.checkboxes-wrapper {
  display: flex;
}
.checkboxes-wrapper .col {
  display: flex;
  gap: 7px;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.log-action {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 5px;
}
.log-action--disabled {
  opacity: 0.5;
  pointer-events: none;
}

@media screen and (min-width: 380px) {
  .checkboxes-wrapper .col {
    margin-right: 15px;
  }
  .checkboxes-wrapper .col:not(:last-child)::after {
    background: #8d98bc;
    content: "";
    height: 80%;
    top: 10%;
    right: 0;
    position: absolute;
    width: 1px;
  }
}

@media screen and (max-width: 380px) {
  .checkboxes-wrapper .col:not(:last-child) {
    margin-bottom: 7px;
  }
}

.inquiry-filters-btns .checkbox-wrapper {
  margin: 0 15px 0 0;
}
.checkbox-wrapper .checkmark {
  background-color: #f4f4f4;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #fff;
}
.checkbox-wrapper:hover input:checked ~ .checkmark {
  background-color: #3b86ff;
}
.inquiry-filters-btns .btn {
  margin: 0;
}
.inquiry-filters-btns .btn-print,
.inquiry-filters-btns .btn-excel {
  margin-right: 10px;
}
/* CONTENT */
.reports-tabs {
  display: flex;
  font-weight: 700;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: -1px;
  position: relative;
}
.reports-tab {
  align-items: center;
  background-color: #ccd1e3;
  border: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  font-weight: 700;
  display: flex;
  height: 45px;
  justify-content: center;
  margin: 0 3px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 33.33%;
}
.reports-tab span:first-child {
  margin-right: 2px;
}
.reports-tab:first-child {
  margin-left: 0;
}
.reports-tab:last-child {
  margin-right: 0;
}
.reports-tab:hover {
  background-color: #d4d8e6;
}
.reports-tab-active {
  background-color: #fff;
  border: 1px solid #ccd1e3;
  border-bottom: 1px solid #fff;
}
.reports-tab-active:hover {
  background-color: #fff;
}
.reports-content {
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #ccd1e3;
  padding: 0 10px;
}
.reports-content .table tbody tr:not(.tr--main) {
  background-color: #f0f0f7;
}
.reports-content .table tbody td {
  padding: 10px;
}
.reports-content .table .td-company-name {
  position: relative;
  padding: 0 20px;
}
.reports-content .table tbody .additional-row {
  background-color: #f0f2d0;
}
.reports-content .table tbody .tr-invalid {
  background-color: #fff8f8;
}
.reports-content .table tbody tr:hover {
  background-color: #e8e8f3;
}
.reports-content .table tbody .additional-row:hover {
  background-color: rgb(230, 233, 194);
}
.reports-content .table tbody .tr--logged {
  background-color: #d7ffe9 !important;
  color: #217346;
}
.reports-content .table tbody .tr--logged:hover {
  background-color: #94f5bf !important;
}
.reports-content .table tbody .tr--logged td:before {
  color: #217346;
}
.reports-content .table tbody .additional-td {
  position: relative;
  padding-left: 35px;
}
.additional-td::before {
  color: #d88e0f;
  font-size: 16px;
  /* font-weight: 700; */
  font-family: "miv";
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.additional-td-material::before {
  content: "G";
}
.additional-td-activity::before {
  content: "O";
}
.reports-content .table tbody .sum-row {
  background-color: transparent;
  font-size: 18px;
  font-weight: 700;
}
.reports-content .table tbody .sum-row td:first-child {
  padding-right: 30px;
  text-align: right;
}
.inquiry-title-wrapper {
  padding: 30px 20px 20px;
}
.inquiry-title {
  color: #3b86ff;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  width: 100%;
}
.inquiry-title-invalid {
  color: #bf392a;
}
.no-reports {
  /* background-color: #fff; */
  /* border-radius: 4px; */
  padding: 20px;
  text-align: center;
  width: 100%;
}
.td-center {
  text-align: center;
}
.table-wrapper {
  overflow: auto;
}
.date-toggles {
  align-items: center;
  display: flex;
}
.date-toggle {
  align-items: center;
  background-color: #ccd1e3;
  border: 1px solid #ccd1e3;
  border-radius: 4px;
  color: #3b86ff;
  cursor: pointer;
  font-size: 24px;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  margin-left: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 36px;
}
.date-toggle:hover {
  border-color: rgba(141, 53, 6, 0.2);
}
.date-toggle-active,
.date-toggle-active:hover {
  background-color: #ffe0b2;
  border-color: #3b86ff;
}
.link {
  color: #006ad2;
  font-weight: 700;
  text-decoration: underline;
}
.difference {
  color: #ff0000;
  font-weight: 700;
}
.not-reported {
  color: #0540c5;
}
.not-reported section {
  display: flex;
  justify-content: flex-start;
}
.not-reported .not-reported--object {
  margin-left: 5px;
}
.vab .tr--main {
  background-color: rgba(21, 21, 147, 0.2);
}
.vab tr {
  height: initial;
}
.vab tr td {
  vertical-align: baseline;
}
/* .desktop { */
/* display: flex; */
/* } */
.mobile,
.print-header,
.print-name {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: inline-grid;
  }
  .inquiry {
    padding: 10px 15px;
  }
  .inquiry-header {
    height: initial;
  }
  .inquiry-header-controlls {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
  }
  .inquiry-pre-datepicker-text {
    font-size: 20px;
  }
  .inquiry-filters-inputs {
    display: flex;
    flex-direction: column;
  }
  .inquiry-datepicker {
    margin-top: 10px;
    padding: 2px 0;
    width: 100%;
  }
  .new-input-wrapper {
    width: 100%;
  }
  .table-wrapper {
    overflow: auto;
  }
  .new-content-data-item-toggle-circle {
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 75px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.top {
    background-color: #083f75;
    margin-top: 50px;
    position: inherit;
  }
  .new-content-data-item-toggle-circle .miv {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 125px;
    padding: 0px;
  }
  .no-wrap {
    white-space: nowrap;
  }

  @media screen and (max-width: 600px) {
    .reports-tab {
      flex-direction: column;
    }
    .reports-tab span:first-child {
      margin: 0;
    }
    .inquiry-filters-btns {
      flex-direction: column;
    }
    .inquiry-filters-btns .btn {
      margin-top: 15px;
    }
  }
  @media screen and (max-width: 380px) {
    .reports-tab {
      font-size: 12px;
    }
    .checkboxes-wrapper {
      flex-direction: column;
    }
  }
}

@media print {
  .inquiry-header,
  .inquiry-filters,
  .inquiry-title-wrapper,
  .reports-tabs,
  .print-hide {
    display: none;
  }
  .inquiry {
    padding: 10px;
    font-family: Cascadia Code;
  }
  .print-header {
    align-items: center;
    background-color: #f6f6f6;
    border-radius: 10px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    text-align: right;
    padding: 15px 22px;
  }
  .print-name {
    display: block;
    font-size: 16px;
    padding: 15px;
    text-align: center;
  }
  .reports-content {
    border: initial;
    padding: 0;
  }
  .reports-content .table thead tr {
    background-color: initial !important;
  }
  .reports-content .table thead th {
    background-color: initial !important;
    border-bottom: 1px solid #707070;
    border-top: 1px solid #707070;
    border-radius: 0 !important;
  }
  .reports-content .table tbody tr {
    background-color: initial !important;
  }
  .reports-content .table tbody tr td {
    background-color: initial !important;
    border-bottom: 1px dashed rgba(112, 112, 112, 0.2);
    font-size: 12px;
  }
  .reports-content .table tbody .sum-row td {
    font-weight: 700;
    font-size: 13px;
  }
  .reports-content .table tbody .sum-row td span {
    font-size: 18px;
  }
  .reports-content .table .print-big-td {
    width: 100%;
  }
}
</style>
